import React, { Component } from 'react';
import Footer from 'pages/Home/Footer2'
import {connect } from "react-redux";
import NoAutorizado from 'commons/NoAutorizado';
import mapStateToProps from './mapStateToProps';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import FormularioCambiarContrasena from './Form'

class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            controller:'user',
            loading: false,
            authorized:true,
            checkAutorization:false,
            create:false,
            update:false,
            delete:false,
            rowData: [],
            data: [],
            currentUser: props.currentUser,
        }
        this.addRegister = this.addRegister.bind(this);
    }

    async addRegister(){ this.setState({create:true}); }

    componentDidMount() {
    }
    render() {

        if (this.state.checkAutorization ) return <IndicadorDeCarga/>
        if (!this.state.authorized &&  !this.state.loading){ return <NoAutorizado/>}

        return (
            <div>
                {this.state.loading ? <IndicadorDeCarga/> : '' }

                <FormularioCambiarContrasena />
                <br/><br/><br/><Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps)(UserProfile);